import { EventNotificationApi } from "./eventNotificationApi";
export class Path {
    constructor(type, id = "*") {
        const validId = id.length === 0 ? "*" : id;
        const path = type.trim().replace("{resId}", validId).toLowerCase();
        if (!EventNotificationApi.REGEX_PATTERN.test(path)) {
            throw new Error("The following path have unsupported character: " + path);
        }
        this.type = type;
        this.id = (validId == "*") ? null : validId;
        this.rabbitMQPath = path;
        this.rabbitMQPathAsList = path.split(".");
    }
    /**
     * Compare the path in input with the current object. Handle the * placeholder.
     * @param path path to compare
     */
    compare(path) {
        const inputPathAsList = path.trim().toLowerCase().split(".");
        if (this.rabbitMQPathAsList.length !== inputPathAsList.length)
            return false;
        for (let i = 0; i < inputPathAsList.length; i++) {
            if (this.rabbitMQPathAsList.at(i) == "*")
                continue;
            if (this.rabbitMQPathAsList.at(i) != inputPathAsList.at(i))
                return false;
        }
        return true;
    }
    /**
     * Generate the resource code from the rabbitMQ path.
     * @return ResCode, or X as default if there is * placeholder
     */
    generateResCode() {
        let str = "";
        let c = 1;
        if (this.rabbitMQPathAsList.at(1) == "divisions") {
            str += "1";
            c += 2;
        }
        else {
            str += "0";
        }
        if (this.rabbitMQPathAsList.at(1) == "divisions" && !isNaN(parseInt((this.rabbitMQPathAsList.at(3) === undefined) ? "" : this.rabbitMQPathAsList[3]))) {
            if (this.rabbitMQPathAsList[3] == "*")
                return "X";
            str += "1" + this.rabbitMQPathAsList[3];
            c += 1;
        }
        else {
            str += "0";
        }
        if (this.rabbitMQPathAsList.at(1) == "divisions") {
            const data = this.rabbitMQPathAsList.at(2);
            if (data == "*")
                return "X";
            str += data;
        }
        for (let i = c; i < this.rabbitMQPathAsList.length - 2; i++) {
            const data = this.rabbitMQPathAsList.at(i);
            if (data == "*")
                return "X";
            str += '/' + data;
        }
        str += '-' + this.rabbitMQPathAsList.at(this.rabbitMQPathAsList.length - 1);
        return str.toLowerCase();
    }
}
